// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - AreaMCP
export class AreaMCP {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /**
     * Retrieves an MCP stream by ID. Users can only access MCP streams associated with themselves.
     * @param streamId - The ID of the MCP stream to retrieve.
     * @returns The MCPStream object.
     */
    async getMCPStream(streamId) {
        return this.dataCore.getMCPStream(streamId);
    }
    /**
     * Retrieves the user's MCP stream. If no MCP stream exists for the user, an empty MCP stream is created automatically.
     * @returns The user's MCPStream object.
     */
    async getUserMCPStream() {
        return this.dataCore.getUserMCPStream();
    }
    /**
     * Lists the MCP consumers (users who have used MCP) of a workspace.
     * Optionally narrows the results to a specific context or design system.
     * @param workspaceId - The ID of the workspace.
     * @param contextId - Optional context to filter by.
     * @param designSystemId - Optional design system to filter by.
     * @returns The list of MCP consumers.
     */
    async listConsumers(workspaceId, contextId, designSystemId) {
        return this.dataCore.listMCPConsumers(workspaceId, contextId, designSystemId);
    }
    /**
     * Returns the effective MCP consumer count for a workspace.
     * Counts only billable viewers, unlike `listConsumers`, whose length includes paid seats.
     * @param workspaceId - The ID of the workspace.
     * @param contextId - Optional context to filter by.
     * @param designSystemId - Optional design system to filter by.
     * @returns The effective MCP consumer count.
     */
    async getConsumerCount(workspaceId, contextId, designSystemId) {
        return this.dataCore.getMCPUsageStats(workspaceId, contextId, designSystemId);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Write
    /**
     * Updates the user's MCP stream with the provided data.
     * @param data - The update input containing optional projectFeatureId and projectDocumentId.
     * @returns The updated MCPStream object.
     */
    async updateUserMCPStream(data) {
        return this.dataCore.updateUserMCPStream(data);
    }
}
